var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvengelism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-people-talking",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-people-talking:not(.animated) .animable {opacity: 0;}svg#freepik_stories-people-talking.animated #freepik--background-simple--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--Trees--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--Clouds--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--character-3--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--speech-bubble-3--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--character-2--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--speech-bubble-2--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--character-1--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--speech-bubble-1--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-people-talking.animated #freepik--Table--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-34",
    className: "animable",
    style: {
      transformOrigin: "370.649px 257.821px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.18,55.62S145,65.39,69.76,152.31,11.17,340.8,173.29,420.89,520,444.33,616.69,398.42,743,216.14,685.05,154.26,527.81,46.83,345.18,55.62Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "370.649px 257.821px"
    },
    id: "elkw4h01ma3xm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh02z0b6drul"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.18,55.62S145,65.39,69.76,152.31,11.17,340.8,173.29,420.89,520,444.33,616.69,398.42,743,216.14,685.05,154.26,527.81,46.83,345.18,55.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "370.649px 257.821px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-34",
    className: "animable",
    style: {
      transformOrigin: "377.051px 291.133px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.39,286.4s50.11,5,75.51,36c0,0,26.83-36,75-35.25a97.4,97.4,0,1,0-150.55-.69Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "286.908px 224.998px"
    },
    id: "elntaxlkky5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elov4c3kfeq2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.39,286.4s50.11,5,75.51,36c0,0,26.83-36,75-35.25a97.4,97.4,0,1,0-150.55-.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "286.908px 224.998px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.56,251.21c25,7.92,40.58,31.19,44.64,37.9l-.37,165.56H291L290,309.45c5.46-8.26,21.07-28.88,45.19-36.25,0,0-28.64,6.79-45.37,29.62l-.93-34.77c4.12-6.61,20.25-30,46.3-38,0,0-30,7.1-46.49,31.19l-.94-35,.06.47s16.92-30.45,47.37-39.75c0,0-31.35,7.44-47.6,32.89l-2.3-47.16-.72,67.6c-15.92-24.22-45-31.34-45-31.34,25.65,8.12,41.34,32.34,44.92,38.37l-.24,34.85C268.26,258.26,239.56,251.21,239.56,251.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.375px 313.68px"
    },
    id: "eldi8u951auob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.56,251.21c25,7.92,40.58,31.19,44.64,37.9l-.37,165.56H291L290,309.45c5.46-8.26,21.07-28.88,45.19-36.25,0,0-28.64,6.79-45.37,29.62l-.93-34.77c4.12-6.61,20.25-30,46.3-38,0,0-30,7.1-46.49,31.19l-.94-35,.06.47s16.92-30.45,47.37-39.75c0,0-31.35,7.44-47.6,32.89l-2.3-47.16-.72,67.6c-15.92-24.22-45-31.34-45-31.34,25.65,8.12,41.34,32.34,44.92,38.37l-.24,34.85C268.26,258.26,239.56,251.21,239.56,251.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.375px 313.68px"
    },
    id: "elchnarnt1azt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.78,314.21s41.83,4.14,63,30.06c0,0,22.4-30,62.63-29.42a81.3,81.3,0,1,0-125.67-.57Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "474.809px 262.974px"
    },
    id: "elhue195navzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliynq6rj1v1l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.78,314.21s41.83,4.14,63,30.06c0,0,22.4-30,62.63-29.42a81.3,81.3,0,1,0-125.67-.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "474.809px 262.974px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.3,284.83c20.9,6.62,33.87,26,37.26,31.64l-.31,138.2h6l-.91-121.22c4.56-6.9,17.59-24.11,37.72-30.26,0,0-23.91,5.67-37.87,24.72l-.78-29c3.44-5.51,16.91-25.06,38.65-31.71,0,0-25,5.93-38.8,26L475.49,264l.05.39s14.12-25.42,39.54-33.18c0,0-26.17,6.21-39.74,27.45l-1.91-39.37-.6,56.43c-13.3-20.21-37.53-26.16-37.53-26.16,21.41,6.78,34.5,27,37.49,32l-.19,29.09C459.25,290.72,435.3,284.83,435.3,284.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "475.19px 336.98px"
    },
    id: "el3eul5c21psi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.3,284.83c20.9,6.62,33.87,26,37.26,31.64l-.31,138.2h6l-.91-121.22c4.56-6.9,17.59-24.11,37.72-30.26,0,0-23.91,5.67-37.87,24.72l-.78-29c3.44-5.51,16.91-25.06,38.65-31.71,0,0-25,5.93-38.8,26L475.49,264l.05.39s14.12-25.42,39.54-33.18c0,0-26.17,6.21-39.74,27.45l-1.91-39.37-.6,56.43c-13.3-20.21-37.53-26.16-37.53-26.16,21.41,6.78,34.5,27,37.49,32l-.19,29.09C459.25,290.72,435.3,284.83,435.3,284.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "475.19px 336.98px"
    },
    id: "elckty2n2v2y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.25,314.21s41.83,4.14,63,30.06c0,0,22.4-30,62.63-29.42a81.3,81.3,0,1,0-125.67-.57Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "106.279px 262.974px"
    },
    id: "el956dd89wexv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elni4w64u1ayg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.25,314.21s41.83,4.14,63,30.06c0,0,22.4-30,62.63-29.42a81.3,81.3,0,1,0-125.67-.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "106.279px 262.974px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.77,284.83c20.9,6.62,33.87,26,37.26,31.64l-.3,138.2h6l-.91-121.22c4.56-6.9,17.59-24.11,37.72-30.26,0,0-23.91,5.67-37.87,24.72l-.78-29c3.44-5.51,16.91-25.06,38.65-31.71,0,0-25,5.93-38.8,26L107,264l.06.39s14.12-25.42,39.53-33.18c0,0-26.16,6.21-39.73,27.45l-1.92-39.37-.6,56.43C91,255.48,66.77,249.53,66.77,249.53c21.41,6.78,34.51,27,37.49,32l-.19,29.09C90.72,290.72,66.77,284.83,66.77,284.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.68px 336.98px"
    },
    id: "elbismglxu7qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.77,284.83c20.9,6.62,33.87,26,37.26,31.64l-.3,138.2h6l-.91-121.22c4.56-6.9,17.59-24.11,37.72-30.26,0,0-23.91,5.67-37.87,24.72l-.78-29c3.44-5.51,16.91-25.06,38.65-31.71,0,0-25,5.93-38.8,26L107,264l.06.39s14.12-25.42,39.53-33.18c0,0-26.16,6.21-39.73,27.45l-1.92-39.37-.6,56.43C91,255.48,66.77,249.53,66.77,249.53c21.41,6.78,34.51,27,37.49,32l-.19,29.09C90.72,290.72,66.77,284.83,66.77,284.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.68px 336.98px"
    },
    id: "elrxmje1fyvsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.43,286.64s50,4.95,75.4,36c0,0,26.79-35.94,74.92-35.2a97.26,97.26,0,1,0-150.34-.69Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "631.863px 225.38px"
    },
    id: "elrbkysokxj7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele72xjcd8qf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.43,286.64s50,4.95,75.4,36c0,0,26.79-35.94,74.92-35.2a97.26,97.26,0,1,0-150.34-.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "631.863px 225.38px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M584.56,251.5c25,7.91,40.52,31.14,44.57,37.85l-.36,165.32H636l-1.08-145c5.45-8.26,21-28.85,45.12-36.21,0,0-28.6,6.79-45.3,29.58l-.94-34.72c4.12-6.59,20.23-30,46.24-37.93,0,0-29.91,7.09-46.42,31.14l-.94-35,.07.46S649.6,196.6,680,187.31c0,0-31.3,7.43-47.53,32.84l-2.3-47.09-.71,67.5c-15.91-24.18-44.9-31.29-44.9-31.29,25.61,8.1,41.28,32.29,44.85,38.32l-.23,34.79C613.22,258.54,584.56,251.5,584.56,251.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "632.3px 313.865px"
    },
    id: "elpznu3vjcjx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.56,251.5c25,7.91,40.52,31.14,44.57,37.85l-.36,165.32H636l-1.08-145c5.45-8.26,21-28.85,45.12-36.21,0,0-28.6,6.79-45.3,29.58l-.94-34.72c4.12-6.59,20.23-30,46.24-37.93,0,0-29.91,7.09-46.42,31.14l-.94-35,.07.46S649.6,196.6,680,187.31c0,0-31.3,7.43-47.53,32.84l-2.3-47.09-.71,67.5c-15.91-24.18-44.9-31.29-44.9-31.29,25.61,8.1,41.28,32.29,44.85,38.32l-.23,34.79C613.22,258.54,584.56,251.5,584.56,251.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "632.3px 313.865px"
    },
    id: "elokffvu64c7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-34",
    className: "animable",
    style: {
      transformOrigin: "381.358px 76.2838px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.16,56c-.22-.68-.45-1.35-.69-2-9-25.06-50.93-26.79-50.93,4,0,5.93-14.24,0-19.58,7.71s.6,12.45-6.52,14.82-7.71-3.55-16.61-3-7.71,8.9-10.67,11.27-3,1.18-9.49,1.78S282,95.94,282,95.94H438s5.93-17.8-4.75-24.32-10.68,2.37-19-1.19C407.36,67.49,406.08,61.91,404.16,56Z",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "360.821px 65.4938px"
    },
    id: "elbxcvuucins6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.55,89.45s3.23-10-4.7-17.34-16.15-3.23-18.5,0-2.35,9.41-6.17,10-2.94-6.46-11.17-4.7-5,10-8.81,11.75-3.82-4.7-9.1-2.64-5,5.87-5,5.87",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "378.149px 80.1981px"
    },
    id: "el5u7q1inegwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.36,69.49a14.88,14.88,0,0,0-15-1.31c-8.51,3.93-4.58,12.1-8.51,14.06s-5.88-.32-10.79,2-4.58,5.56-4.58,5.56",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "347.918px 78.2706px"
    },
    id: "elbutpqgeczbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,100.18c-.1-.29-.19-.59-.3-.88C221.74,88.4,203.5,87.64,203.5,101c0,2.58-6.19,0-8.51,3.36s.25,5.41-2.84,6.45-3.36-1.55-7.23-1.29-3.35,3.87-4.64,4.9-1.29.52-4.13.77a3.53,3.53,0,0,0-3.36,2.33h67.87s2.58-7.75-2.07-10.58-4.64,1-8.25-.52C227.35,105.18,226.79,102.75,226,100.18Z",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "207.082px 104.285px"
    },
    id: "el9v3l3te5wtp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.31,114.73a7.59,7.59,0,0,0-2.05-7.54c-3.45-3.19-7-1.4-8,0s-1,4.09-2.68,4.35-1.28-2.81-4.86-2.05-2.17,4.35-3.83,5.12-1.67-2-4-1.16S200.7,116,200.7,116",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "214.647px 110.704px"
    },
    id: "elpyfeevj9or",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,106.05a6.48,6.48,0,0,0-6.55-.57c-3.7,1.71-2,5.27-3.7,6.12s-2.56-.14-4.69.85-2,2.42-2,2.42",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "201.529px 109.859px"
    },
    id: "el4ff0lmu5vbf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.51,98.86c-.09-.29-.19-.58-.3-.88-3.92-10.9-22.15-11.65-22.16,1.74,0,2.58-6.19,0-8.51,3.36s.26,5.42-2.84,6.45-3.35-1.55-7.22-1.29-3.36,3.87-4.65,4.9-1.29.52-4.13.78a3.5,3.5,0,0,0-3.35,2.32h67.86s2.58-7.74-2.06-10.58-4.65,1-8.26-.52C575.91,103.86,575.35,101.44,574.51,98.86Z",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "555.638px 102.989px"
    },
    id: "elf7w386zoqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.86,113.42a7.56,7.56,0,0,0-2.05-7.54c-3.45-3.2-7-1.41-8,0s-1,4.09-2.68,4.34-1.28-2.81-4.86-2-2.17,4.34-3.83,5.11-1.66-2.05-4-1.15-2.18,2.55-2.18,2.55",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "563.204px 109.41px"
    },
    id: "elwerwmhzu1ma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5,104.73a6.48,6.48,0,0,0-6.54-.57c-3.7,1.71-2,5.27-3.7,6.12s-2.56-.14-4.7.86-2,2.42-2,2.42",
    style: {
      fill: "none",
      stroke: "rgb(178, 178, 178)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "550.029px 108.546px"
    },
    id: "el73beqxaa9zj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-34",
    className: "animable",
    style: {
      transformOrigin: "569.406px 300.06px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.29,422.5s-3.79,19.89-4,21.07-1.42,10.89-1.42,10.89l18.23-.24-1.89-15.15,4.73-13.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "500.405px 438.48px"
    },
    id: "el6f98fgd9oq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.78,332.53s-24.15,77.66-25.1,83.1-.71,7.58-.71,7.58L513,428.42l7.82-19.65.23-82.16Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "506.496px 377.515px"
    },
    id: "elfkk6h4t36o6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.13 454.67 516.75 417.87 614.53 419.23 617.14 454.48 512.13 454.67",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "564.635px 436.27px"
    },
    id: "elzysa67hokc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,415.86l-.53,10.07s11.26,9.55,45.19,9.28,45.2-4.51,48.65-5.57,5.83-2.39,5.83-4.77a69.86,69.86,0,0,0-1.33-8.75s-30.74,4-54.07,4.77A158.75,158.75,0,0,1,516,415.86Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "565.305px 425.538px"
    },
    id: "elb01uhs1vttb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.86,256.78s-19.39,13.15-20.64,17.42-14.56,44.91-13.81,50.69,1.26,22.83,1.26,22.83-6,66-4,69.76,23.59,9.78,55,8.78,44.66-5.77,45.92-7,2.76-3.51,2.25-7.52-.5-30.12-.5-30.12l19.07-7s-8.53-104.14-11.79-109.66-30.86-13.8-35.13-13.55S550.86,256.78,550.86,256.78Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "574.336px 338.887px"
    },
    id: "elqqdxk6tj70a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 538.14,
    y1: 338.33,
    x2: 561.56,
    y2: 352.77,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "549.85px 345.55px"
    },
    id: "elr3jo7zlr78p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.17,
    y1: 333.41,
    x2: 535.6,
    y2: 336.76,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "532.885px 335.085px"
    },
    id: "el04ab5wyv77sb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 568.15,
    y1: 353.2,
    x2: 570.97,
    y2: 354.86,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "569.56px 354.03px"
    },
    id: "ell3mwul6re3t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 553.19,
    y1: 344.4,
    x2: 564.71,
    y2: 351.18,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "558.95px 347.79px"
    },
    id: "eljp0h7eqe0am",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.46,175.19s-3.84,15.93-3.84,17.66,1.34,5.57,1.15,6.53S523,210.9,524.36,212.43s4.61,6.34,4.61,6.34,4.61,20.16,6.33,20.16,16.32-3.46,16.32-3.46l-.76,21.31-4,4s-2.49,22.85.58,22.47,42.24-29.19,42.81-30.72-.38-2.5-1.53-3.07-4-5.38-4-5.38-1.92-23.81-1.92-24.38,4.79-21.12,5.18-21.7,2.69-10.75-13.25-18-34.56-9.22-36.09-8.64S536.46,175.19,536.46,175.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "557.33px 227.26px"
    },
    id: "el3riyi4tc1vp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "551.62 235.47 561.77 233.9 552.01 244.69 551.62 235.47",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "556.695px 239.295px"
    },
    id: "eldnzsyf3u9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,219.34s5.95.58,10-3.64c0,0-.19,7.29-2.88,8.25S534,219.34,534,219.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "539px 219.881px"
    },
    id: "eli6br8ru5mg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.72,198.8c0,1.27-.47,2.31-1.06,2.31s-1-1-1-2.31.47-2.3,1-2.3S539.72,197.53,539.72,198.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "538.69px 198.805px"
    },
    id: "eloo4yvmrkedd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.07,190.94s2.75-2,7.49,0",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "539.815px 190.496px"
    },
    id: "elrna57qrooq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.41,152.2s-9.51-6.75-16.57-6.75-12.58,5.22-12.58,9.2,1.53,7.06-.31,8.6-6.14-3.07-8.59,3.37,8,12.89,10.13,13.5,5.52-4,7.36-2.45,2.76,4.91,7.36,4.91,8.9-3.68,10.13-1.84-1.84,7.36.31,8.9,6.44,5.21,6.44,5.21-2.15,5.83-.61,6.45l1.53.61s2.76-6.44,6.75-5.83S575,198.23,575,205s-7.37,9.2-7.37,9.2,7.06,8.29,9.21,8.9,5.52,2.76,6.75.62,8-15.35,9.21-16.88,10.12-1.84,12-8.9-3.37-10.43-1.22-12.58,11-3.07,8.28-12.58-10.13-10.13-12.89-11-6.13-8-10.43-9.82-6.75-.61-7.67-.3-1.54-4.3-10.43-3.38S558.41,152.2,558.41,152.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "566.182px 185.049px"
    },
    id: "elgd6kuleaba4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.08,206.53c-2.43,0-5.38-.92-6.37-2.09-1.32-1.53-2.2-9.49-1.33-12a1.82,1.82,0,0,1,1.31-1.35c.26,0,.93-.18,11.24.43a2.92,2.92,0,0,1,2.73,3.32h0c-.24,1.79-.57,4.24-.69,5.05a10.85,10.85,0,0,1-4.34,6.11A5.42,5.42,0,0,1,537.08,206.53Zm-5.8-13.48c-.57,1.37-.09,8.76,1,10.1.84,1,5.09,1.86,6.43,1.11a9.34,9.34,0,0,0,3.33-4.64c.12-.81.45-3.25.69-5h0a1,1,0,0,0-.2-.72,1,1,0,0,0-.67-.33C535.29,193.14,532.15,193,531.28,193.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "536.86px 198.8px"
    },
    id: "eln2wt0u5fqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "543.67 194.71 566.02 197.65 564.1 199.38 549.9 198.23 547.4 199.38 542.98 199.76 543.67 194.71",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "554.5px 197.235px"
    },
    id: "el4s45d7wormx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.48,358.5s-7.45-7.61-6.18-8.56a3.74,3.74,0,0,1,4.92.64c1.42,1.58,9,10.78,9,10.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "516.187px 355.328px"
    },
    id: "elp1v5ixndvlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.16,365.48s-7.77-3.81-9.36-4.76-9.67-6-8.72-7.13,3.65-1.59,5.55.31,9.51,5.4,10,5.55,4.28,5.39,4.28,5.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "516.956px 359.044px"
    },
    id: "elebyplb18yc6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.11,365.32s-10.94-4.44-11.73-4.91-2.54-4.13-5.08-6-5.55-2.38-8.08-3.33a85.39,85.39,0,0,1-8.25-4c-.79-.48-4,1.9.32,5.23s7.45,5.71,7.45,5.71-6.34.31-8.4.63-6.5-.16-7.14-1-5.23-7.13-6.65-8.4-4.6-1.75-5.24.31,1.75,1.91,5.39,7,8.57,11.89,11.1,11.73,21.25,1.91,21.25,1.91l16.65,7.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "539.453px 362.414px"
    },
    id: "elwbhpjqnwou8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.73,290.26s-6.52,22.83-4.77,29.61S610.26,362,610.26,362s-35.63.75-39.9.75a32.84,32.84,0,0,0-6.52.51l-.25,22.08s30.86,8,51.19,6,32.87-5,33.62-8.53a32.34,32.34,0,0,0,.5-7.53s-12.29-73.52-15.56-85.56-6.77-25.85-9.53-27.86-18.32-4.76-18.32-4.76",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "606.266px 324.38px"
    },
    id: "elp5hjte9uy3",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-3--inject-34",
    className: "animable",
    style: {
      transformOrigin: "631.705px 103.755px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.49,60.75H589.92a9.68,9.68,0,0,0-9.68,9.68v46.65a9.68,9.68,0,0,0,9.68,9.68h31.29l-7.56,20,18.62-20h41.22a9.68,9.68,0,0,0,9.68-9.68V70.43A9.68,9.68,0,0,0,673.49,60.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "631.705px 103.755px"
    },
    id: "ellqquq0fcw27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.91,92.38A4.64,4.64,0,1,0,609.27,97,4.64,4.64,0,0,0,613.91,92.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "609.27px 92.36px"
    },
    id: "el6ecmbbiday",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.34,92.38A4.64,4.64,0,1,0,631.7,97,4.64,4.64,0,0,0,636.34,92.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "631.7px 92.36px"
    },
    id: "elh3vrtbno9s4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.78,92.38A4.65,4.65,0,1,0,654.14,97,4.64,4.64,0,0,0,658.78,92.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "654.13px 92.35px"
    },
    id: "elyrco2ax0zu",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-34",
    className: "animable",
    style: {
      transformOrigin: "380.08px 300.101px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.68,454.67c.26-4.75.59-12.32.26-15.15-.5-4.24-10.83-34.57-10.83-34.57l-119.69-.12-3.2,49.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "378.149px 429.75px"
    },
    id: "elfdmifehsjjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.69,408.08,439,411.57l-7.24,6,13.23,22s5.24-5.49,6-7.73,2.49-9,2.49-9l1.5-3.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "443.37px 423.825px"
    },
    id: "elo5o39bnl4dk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.24,246.34s-42.27,13-43.86,19.39-25.75,71.83-25.75,71.83l38.46,4.13s-8.58,64.53-7,66.44,53.4,3.81,62.93,4.13,58.81-5.09,60.08-7.31.95-7.31.95-7.31l-1.59-47.05.32-19.38,17.48,34.32s5.09,4.14,14.3,2.86,15.9-5.4,14-18.11-27-70.88-29.88-79.47S444,258.1,439.51,255.87s-47.68-13-47.68-13Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "379.757px 327.572px"
    },
    id: "el410gc80vc7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.79,
    y1: 331.21,
    x2: 435.06,
    y2: 288.93,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "434.425px 310.07px"
    },
    id: "elqx56ty090l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.06,
    y1: 314.36,
    x2: 439.19,
    y2: 290.84,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "437.125px 302.6px"
    },
    id: "elp3ok5gant2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.09,
    y1: 341.69,
    x2: 322.86,
    y2: 284.48,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "320.475px 313.085px"
    },
    id: "elaqfx4hwmmtu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 308,
    x2: 316.5,
    y2: 285.12,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "318.25px 296.56px"
    },
    id: "el8jo5olc9ejs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.56,236.8s-9.54,7.63-9.22,9.22.32,8.58,3.81,10.17,25.75,19.07,25.75,19.07Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "355.116px 256.03px"
    },
    id: "eli8wz7yxfrv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.42,210.56l4.77,39.28,19.71,25.42,23.52-35,.32-24.48s-2.23,7.32-15.89,6.68S345.42,210.56,345.42,210.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "369.58px 242.91px"
    },
    id: "elx73drkvxl1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.84 231.5 349.56 236.8 344.66 206.63 369.84 231.5",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "357.25px 221.715px"
    },
    id: "elrqpbrjg1azn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.9,275.26s7-22.56,7.63-25.74,16.85-15.9,16.85-15.9a3.11,3.11,0,0,1,3.17,3.18c0,3.18.32,7,.32,7Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "383.885px 254.44px"
    },
    id: "eliagtmtvzo3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.19,187.38s4.45-3.5,6.67,1.9-4.76,14-6.35,15.58l-1.59,1.59s-1-8.9-1-12.08S395.33,186.74,398.19,187.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "400.581px 196.357px"
    },
    id: "elm65x9r2r97e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.13,192.12s-4.77.63-4.78,4.77,2.54,9.85,5.72,11.76a13.61,13.61,0,0,0,6.35,1.91s.95,7.63,5.39,12.72,10.17,8.91,13,10.82,9.21,4.77,13,3.19,9.54-7.3,9.54-7.3a15,15,0,0,0,7.63-9.22c2.23-7,4.79-19.06,4.79-25.1s-1.58-13.35-1.89-15.26-5.4-9.22-20.34-9.23-27,4.74-29.25,8.24S338.13,192.12,338.13,192.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "366.06px 204.464px"
    },
    id: "elinu4yq451th",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,190l1.84,7.82s1.84.23,1.84-1.15-1.86-9.3-1.86-9.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "343.84px 192.602px"
    },
    id: "elr1ufo0qni9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,206.13s-.32,2.55,3.17,3.5,8.58,0,9.22-1.9a6.69,6.69,0,0,0-.31-4.13",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "375.287px 206.801px"
    },
    id: "elyrcd9j9xr2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,214.39a20.46,20.46,0,0,0,19.39-1.57",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "374.505px 214.472px"
    },
    id: "elikmdolpst5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.34,
    cy: 194.53,
    rx: 2.07,
    ry: 3.02,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.34px 194.53px"
    },
    id: "el5t8ewvxenwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.86,194.53c0,1.67-.93,3-2.07,3s-2.06-1.35-2.06-3,.92-3,2.06-3S387.86,192.86,387.86,194.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.795px 194.53px"
    },
    id: "elspgjih3eete",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.19,189.92A13.18,13.18,0,0,1,369,187.06",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "363.095px 188.299px"
    },
    id: "el41yocqb2og5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,186.42a12.78,12.78,0,0,1,11.12,2.23",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "386.56px 187.317px"
    },
    id: "elap7sejwxunc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.84,187.38s-3.18,4.76-5.72,4.76-11.13-6.67-11.77-12.39,12.4-10.17,17.17-17.17,17.48-18.75,27.65-16.84,16.85,13,23.21,14.94S410.9,168.94,410,175.3s-3.5,9.22-6,9.53-5.72-1.59-5.72-1.59-8.9-10.48-21.61-12.07-17.17,1.59-21.62,6.35A106.7,106.7,0,0,1,343.84,187.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "368.192px 168.836px"
    },
    id: "elyz3nso0etz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.84,187.38a10.78,10.78,0,0,0,9.85-1c5.4-3.18,8.58-11.44,21.93-9.21s14.94,6.67,18.12,7.31,4.45.31,3.18-4.14-12.4-12.39-23.52-13S344.47,177.84,343.84,187.38Z",
    style: {
      fill: "rgb(89, 89, 89)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "370.623px 177.724px"
    },
    id: "elkl2x382425",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.77,314.39s3.86-11.48,5-12.85,8.59-4.2,8.59-4.2l4.88-2.16a1.19,1.19,0,0,1,1.64.81c.53,2.18.35,2.59-.9,3.77-1.48,1.39-7.32,4.1-7.32,4.1l10.8-2.35,17.95-3.7a1.35,1.35,0,0,1,1.63,1.22v0c.06.75-15.13,6.6-15.13,6.6l.25,1.49,12.06-1.1,5.09-.79a1.87,1.87,0,0,1,2.11,1.43h0a1.87,1.87,0,0,1-1.05,2.14c-1.82.82-4.78,2.16-5.12,2.27s-12,2.34-12,2.34l6.54,1.86,11.09-.11a1.19,1.19,0,0,1,1.19,1.16h0a1.16,1.16,0,0,1-.6,1.05A35.56,35.56,0,0,1,383,319.6c-1.59.5-7,1.44-8.38,1.67s-6,.49-6.35.52,8,1.23,8.38,1.32,5,.35,4.95.86.1,1.24-.75,1.56a31.29,31.29,0,0,1-7.6.49c-3.39-.1-7.9-.12-7.9-.12s-9.16,1.37-12.89,1.67-8.78,1.34-8.78,1.34l-6.91,2.81-3-15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "360.92px 313.399px"
    },
    id: "ela4g4yjqd2vm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37,315l3.75,17S295,367.4,294.2,367.4s-5.74.75-12-4.74-7.73-13.23-6.74-18.22,6-11.23,8.49-13.48S338.37,315,338.37,315Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "308.649px 341.217px"
    },
    id: "elk0sh9tezlp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.15,352.18s-9,7.48-11,11-12.23,45.92-12.23,45.92l15.73,13.72,8.23-11.23s19.22-43.17,20-46.17-3-14.22-7-19.71",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "462.951px 384.265px"
    },
    id: "elms3pndumy29",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-34",
    className: "animable",
    style: {
      transformOrigin: "440.91px 130.895px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.69,87.89H399.13a9.68,9.68,0,0,0-9.68,9.68v46.65a9.68,9.68,0,0,0,9.68,9.68h31.29l-7.56,20,18.62-20h41.21a9.68,9.68,0,0,0,9.68-9.68V97.57A9.68,9.68,0,0,0,482.69,87.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "440.91px 130.895px"
    },
    id: "elzgk4qxqv8um",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.76,121a4.65,4.65,0,1,0-4.64,4.64A4.64,4.64,0,0,0,423.76,121Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.11px 120.99px"
    },
    id: "el8eov4q84qhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.19,121a4.64,4.64,0,1,0-4.64,4.64A4.64,4.64,0,0,0,446.19,121Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "441.55px 121px"
    },
    id: "eldfnzia4y8a4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.62,121a4.64,4.64,0,1,0-4.64,4.64A4.64,4.64,0,0,0,468.62,121Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "463.98px 121px"
    },
    id: "elf8pmvh7xys8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-34",
    className: "animable",
    style: {
      transformOrigin: "160.865px 299.962px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.66,147.14s-26.8,18.21-27.14,24.4-1,23.36-4.47,26.46-10,8.24-10,12,1.37,8.59,1.37,10.31-4.12,4.81-4.47,8.59,2.07,11,2.07,13.06-5.5,5.5-6.19,8.24,1,4.47-.69,7.22-5.15,7.22-5.15,7.22,6.18,7.55,27.83,11,52.92,4.47,66,1.72S241,257.78,241,257.78s-2.41-1.37-2.41-5.15,4.81-9.62,2.41-14.09-7.91-4.81-7.91-11.34,2.41-5.5,0-10.31-7.56-5.49-8.24-9.27,3.78-8.59,1-14.44-8.59-10-9.62-12.71,2.06-10.31-1.38-14.77-27.14-18.22-35.05-19.93S163.66,147.14,163.66,147.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "175.33px 212.095px"
    },
    id: "el7pw0swls27b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07,216.15c-2.56,16.38-15.86,27.62-15.86,27.62v8.7l-9.91-1.16-24.88-2.93v-22a34.41,34.41,0,0,1-5.11-.51c-3.07-.51-6.66-6.13-3.59-16.88s8.7,2,8.7,2,2,.51,9.21-13.3S177.37,165,177.37,165l27.12,14.84S210.62,199.78,208.07,216.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "178.12px 208.735px"
    },
    id: "elc5fe7kqref6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.89,194.82s-1.66,4.74-1.66,6.17,3.79,17.07,4.27,18-9.25,2.37-9.25,2.37",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "193.884px 208.09px"
    },
    id: "elpjsmggijzri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.26,225.18s-9.72,3.79-15.41-1.9",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "190.555px 224.848px"
    },
    id: "elkdo7ipssfgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.69,191s-8.3-1.43-12.57,3.79",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "179.405px 192.805px"
    },
    id: "elu8cpo0hiqkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,191.5s5.93-1.66,8.3,2.14",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "202.15px 192.39px"
    },
    id: "elbt51nmxnw34",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,202.05c0,2-.94,3.63-2.1,3.63s-2.09-1.63-2.09-3.63.94-3.63,2.09-3.63S182.38,200.05,182.38,202.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.285px 202.05px"
    },
    id: "el0oqt9s2obbzo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.28,202.05c0,2-.94,3.63-2.09,3.63s-2.1-1.63-2.1-3.63.94-3.63,2.1-3.63S204.28,200.05,204.28,202.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "202.185px 202.05px"
    },
    id: "el5map6wky3bs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.21,243.77v8.7l-9.91-1.16c-7.36-6.22-14.18-17.4-14.68-18.24C176,245.58,192.21,243.77,192.21,243.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "179.915px 242.77px"
    },
    id: "elvlq4lk7mu1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,271.42s28.46,102.85,30.53,113.16,7.21,56.18,7.21,56.18l1.55,13.4h-17l3.61-19.59-20.1-67s-7.22-49.48-7.74-63.4S220.93,271.42,220.93,271.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "239.569px 362.79px"
    },
    id: "elcybkr8uz4cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,271.42s-2.46,18.83-2,32.75,7.74,63.4,7.74,63.4L234.63,394l17.9-2.83c-.4-2.77-.77-5.05-1.07-6.55C249.39,374.27,220.93,271.42,220.93,271.42Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "235.701px 332.71px"
    },
    id: "elgb2v4299ric",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.62 269.64 181.36 296.44 200.43 269.12 190.12 261.91 162.29 260.36 156.62 269.64",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "178.525px 278.4px"
    },
    id: "elvx1gcfcowye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.57 266.55 205.07 271.18 229.29 415.5 233.42 454.67 123.63 454.67 136 277.37 158.85 263.97 188.57 266.55",
    style: {
      fill: "rgb(201, 201, 201)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "178.525px 359.32px"
    },
    id: "elkakkp4ro1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.9,
    y1: 331.49,
    x2: 204.55,
    y2: 333.03,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "185.225px 332.26px"
    },
    id: "elcpq7i7q4phg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186,
    y1: 332,
    x2: 184.45,
    y2: 353.14,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "185.225px 342.57px"
    },
    id: "el0g2nup9ejimd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.12,
    y1: 333.55,
    x2: 189.61,
    y2: 372.21,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "189.865px 352.88px"
    },
    id: "elxouv0dwvrpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.24,
    y1: 344.37,
    x2: 195.28,
    y2: 363.96,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "194.76px 354.165px"
    },
    id: "elwp0lvrzw6bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57,262.59s-25.08,13.4-26.11,17.87-13.23,60.82-13.23,61.85,12.2,33,12.2,33l-2.53,50.25s12.37,2.75,19.93,2.41,18.9-1,18.9-1l1.84-164.34Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "135.4px 345.295px"
    },
    id: "elgbnch15xn7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.94,
    y1: 358.8,
    x2: 138.58,
    y2: 318.09,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "136.26px 338.445px"
    },
    id: "el52688jcxqsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.11,352.62,107.65,287s-3.78-10.31-6.87-13.06-6.53-4.81-8.59-6.87-2.4-6.87-3.78-1.72,4.13,8.94,4.13,8.94L96,280.12,74,276s-11.34-5.49-12.37-3.09,4.81,4.47,9.62,8.25,7.56,7.21,15.46,10a47.34,47.34,0,0,1,14.09,8.25s1.72,69.75,5.84,72.85,18.22,11.33,23.37,4.46S135.14,363.62,134.11,352.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.0817px 321.216px"
    },
    id: "elo87i4mfix89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.11,352.62,129.84,342l-26.64,9c.88,11.24,2,20.14,3.42,21.21,4.13,3.09,18.22,11.33,23.37,4.46S135.14,363.62,134.11,352.62Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "118.924px 360.666px"
    },
    id: "elwp7lfymmm8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,288s-9.08-5.51-10.73-8.26-7.43-13.48-5.5-13.75,7,7.58,7.15,8.8,5.78,6.6,5.78,6.6",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "74.6901px 276.992px"
    },
    id: "elvk7okb06sdi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.78,290.18A16.82,16.82,0,0,1,78,283c-2.2-4.95-4.68-11.83-4.68-15.68s2.2-2.47,3,.28S79.92,277,81,278.35s5,6.88,5,6.88",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "79.66px 277.563px"
    },
    id: "elhjuthql9gu5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,292.93c-.28-.83-3.85-6.6-4.95-6.88s-8.53,1.65-8.53,1.65l-5-3.85s-.28-8.25-.28-11.28-4.13,4.4-4.4,9.35,3.58,10.18,3.58,10.18,4.4.83,5.22,1.1,10.13,6.16,10.13,6.16",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "93.4132px 285.613px"
    },
    id: "el0tpsr9sz797r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.95 262.59 147.51 363.27 162.29 362.93 158.85 263.97 150.95 262.59",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "154.9px 312.93px"
    },
    id: "el34uw96k4dnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.95 262.59 157.82 371.18 179.13 370.83 165.04 263.63 150.95 262.59",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "165.04px 316.885px"
    },
    id: "elfjyu6gs15hg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.79,267.58l.13,1.94,10.69,154.74L235,422.41l-7.74-71.85s-4.76-78.11-6.3-79.14S195.79,265,195.79,265Z",
    style: {
      fill: "rgb(255, 193, 0)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "215.395px 344.63px"
    },
    id: "eljg9n83uot1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,242.66s35,6.88,38.14,6.88,5.15,2.06,4.46,4.46a23.57,23.57,0,0,0-1,5.84c0,1.38,3.78,6.88.69,9.63s-35.39-2.41-39.86-2.75-8.59-.69-8.59-3.1,5.15-6.52,5.15-8.24S149.23,248.51,154.39,242.66Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "173.062px 256.467px"
    },
    id: "el3pg1nrqlxgx",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-34",
    className: "animable",
    style: {
      transformOrigin: "109.2px 110.175px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.66,62.26h93.08A10.78,10.78,0,0,1,166.52,73v52a10.78,10.78,0,0,1-10.78,10.78H120.89l8.42,22.31-20.74-22.31H62.66A10.78,10.78,0,0,1,51.88,125V73A10.78,10.78,0,0,1,62.66,62.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "109.2px 110.175px"
    },
    id: "el4dkcfg9m59i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.57,99.31A4.64,4.64,0,1,0,86.93,104,4.64,4.64,0,0,0,91.57,99.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.9303px 99.36px"
    },
    id: "elp425u0pnwdd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,99.31a4.64,4.64,0,1,0-4.64,4.64A4.64,4.64,0,0,0,114,99.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.36px 99.31px"
    },
    id: "elotcsv781py",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.43,99.31a4.64,4.64,0,1,0-4.64,4.64A4.64,4.64,0,0,0,136.43,99.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.79px 99.31px"
    },
    id: "el4etrzh27kmu",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-34",
    className: "animable",
    style: {
      transformOrigin: "373.735px 454.67px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 35.02,
    y1: 454.67,
    x2: 712.45,
    y2: 454.67,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "373.735px 454.67px"
    },
    id: "elo3cp8k3nlf",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvengelism);
export default __webpack_public_path__ + "static/media/evengelism.3717f78080054ee362a61a8ecb829c05.svg";
export { ForwardRef as ReactComponent };